<template>
  <div class="home_box" style="position: relative">
    <div class="home_log">
      <img src="../../assets/img/storefront/Home.jpg" alt="" />
    </div>
    <!-- background-img: url(http://192.168.1.227:8081/proudun/backdrop.png); -->
    <div class="home_List" style="">
      <!-- <img src="../../img/backdrop.jpg" mode="aspectFit"  alt="" /> -->
      <div class="home_List_h1">
        <img src="../../assets/img/storefront/house.png" alt="" />
        <div class="home_List_h1_m1">合作单位</div>
        <div class="home_List_h1_m2">
          （您可以从以下合作单位中任选一个进行产品体验）
        </div>
        <div class="home_List_item" v-for="(item, index) in list" :key="index">
          <div style="padding: 0 0.3rem">
            <div class="home_List_item_l">
              <img :src="item.img" alt="" />
            </div>
            <div class="home_List_item_r">
              <div class="home_List_item_r_h1">{{ item.name }}</div>
              <div class="home_List_item_r_h2">
                <div
                  class="home_List_item_r_h2_itme"
                  :class="
                    index == 0
                      ? 'SpecialBackground_1'
                      : index == 1
                      ? 'SpecialBackground_2'
                      : 'SpecialBackground_3'
                  "
                  :style="index == 1 ? 'margin:0 0.2rem;' : ''"
                  v-for="(items, index) in item.label"
                  :key="index"
                >
                  {{ items }}
                </div>
              </div>
              <div class="home_List_item_r_h3">
                <div
                  class="home_List_item_phone"
                  @click="openPhone(item.phone)"
                >
                  <img src="../../assets/img/storefront/phone.png" alt="" />
                  <div>{{ item.phone }}</div>
                </div>
                <div
                  class="home_List_item_orientation"
                  @click="openAddress(item)"
                >
                  <img
                    src="../../assets/img/storefront/orientation.png"
                    alt=""
                  />
                  <div>{{ item.cartographicInformation.address }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home_base">更多单位陆续加入中，敬请期待...</div>
    </div>
    <el-drawer
      :with-header="false"
      :visible.sync="drawer"
      direction="btt"
      class="storefrout_drawer"
    >
   
      <div
        class="storefrout_map"
        @click="onSelect(item)"
        v-for="(item, index) in actions"
        :key="index"
      >
    
        {{ item.name }}
      
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { otherProudun } from "../../api/index";
export default {
  data() {
    return {
      pageNum: 1,
      list: [
       
      ],
      CallAgain: true,
      actions: [
        { id: "1", name: "高德地图" },
        { id: "2", name: "百度地图" },
      ],
      drawer: false,
      lng: "",
      lat: "",
      glng: "",
      glat: "",
      city: "",
      address:'',
      CallAgain:true
    };
  },

  mounted() {
    this.basics()
    window.addEventListener("scroll", this.scrolling);

  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrolling);
  },
  methods: {
    scrolling() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
 
 let scrollHeight=document.documentElement.scrollHeight//滚动条的高度
 let clientHeight=document.documentElement.clientHeight//浏览器的可视高度
if(this.CallAgain) {
  if(scrollTop+clientHeight+100 >= scrollHeight){
   this.CallAgain = false
    let page =  +this.pageNum+1
    otherProudun({
      pageNum:page
    }).then(res => {
      if(res.result.length) {
           let ts = this.list
        for (let i = 0; i < res.result.length; i++) {
          ts.push(res.result[i]);
        }
       this.data = ts;
       this.pageNum = page
       this.CallAgain = true
      }else {
        this.CallAgain = false
      }
     
  })
 }
}
    },
    bd09togcj02(bd_lng, bd_lat) {
      var x_PI = (3.14159265358979324 * 3000.0) / 180.0
  var bd_lng = +bd_lng
  var bd_lat = +bd_lat
  var x = bd_lng - 0.0065
  var y = bd_lat - 0.006
  var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_PI)
  var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_PI)
  var gg_lng = z * Math.cos(theta)
  var gg_lat = z * Math.sin(theta)
  console.log(gg_lng, gg_lat)
  this.glng =gg_lng
  this.glat =gg_lat
  return [gg_lng, gg_lat]
},
    openAddress(e) {
      console.log(e);
      this.lng = e.cartographicInformation.longitude;
      this.lat = e.cartographicInformation.latitude;
      this.city = e.cartographicInformation.name;
      this.address = e.cartographicInformation.address;
      this.drawer = true;
this.bd09togcj02(e.cartographicInformation.longitude,e.cartographicInformation.latitude)
    
    },
    openPhone(e) {
      window.location.href = "tel://" + e;
    },
    onSelect(item) {
      let c = this.city
      let lng= this.lng;
      let lat= this.lat;
      let glng= this.glng;
      let glat= this.glat;
      let address= this.address;
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起

      /* Start  判断手机是IOS还是安卓 */
      let u = navigator.userAgent;
      //判断是否安卓
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
      // 判断是否IOS
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      //判断是否点击高德地图
     
      if (item.id == 1) {
        //判断是否是安卓手机
        if (isAndroid) {
          window.location.href = `amapuri://route/plan/?sourceApplication=amap&sid=&slat=${glat}&slon=${glng}&dname=${this.city}&dev=0&t=0`;
				//判断是否跳转
                setTimeout(function(){
                    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden ||window.document.webkitHidden 
                    if(typeof hidden =="undefined" || hidden ==false){
                        //调用高德地图
                        window.location.href ="https://uri.amap.com/marker?position="+glat+","+glng+"&name="+c;
                       
                    }
                }, 2000);

        } else if (isIOS) {
          window.location.href = `iosamap://path?sourceApplication=APP&dname=${this.city}&dlat=${glat}&dlon=${glng}&dev=0`;
         
         
				//判断是否跳转
	  			setTimeout(function(){
                    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden ||window.document.webkitHidden 
                    if(typeof hidden =="undefined" || hidden ==false){
                        //调用高德地图
                        window.location.href ="https://uri.amap.com/marker?position="+glat+','+glng+"&name="+c;
                    }
                }, 2000);


        }
        //百度地图
      } else if (item.id == 2) {
        if (isAndroid) {
          let queryStr = `?region=${this.city}&destination=${this.lng},${this.lat}&mode=driving&src=andr.baidu.openAPIdemo`;
          window.location.href=`bdapp://map/direction${queryStr}`;
				//判断是否跳转
                setTimeout(function(){
                    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden ||window.document.webkitHidden 
                    if(typeof hidden =="undefined" || hidden ==false){
                        window.location.href ="http://api.map.baidu.com/marker?location="+lng+","+lat+"&title="+c+"&content="+address+"&output=html";
                    }
                }, 2000);

        } else if (isIOS) {
          let queryStr = `?region=${this.city}&destination=${this.lng},${this.lat}&mode=driving&src=ios.baidu.openAPIdemo`;
          window.location.href = `baidumap://map/direction${queryStr}`;
        
        
				//判断是否跳转
          let c = this.city
	  			setTimeout(function(){
                    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden ||window.document.webkitHidden 
                    if(typeof hidden =="undefined" || hidden ==false){
                        //调用高德地图
                        console.log(lng,lat)
                        window.location.href ="http://api.map.baidu.com/marker?location="+lng+','+lat+"&title="+c+"&content="+address+"&output=html";
                    }
                }, 2000);

        }
      } 

      this.drawer = !this.drawer;
    },

    basics() {
      otherProudun({
        pageNum: this.pageNum,
      }).then((res) => {
        if (res.result) {
          this.list = res.result;
        }
      });
    },
  },
};
</script>

<style>
@import "../../assets/css/mobile/storefront.css";
</style>


// WEBPACK FOOTER //
// src/views/storefront/index.vue